module.exports = __webpack_public_path__ + "static/Adeyinka-8b36d0b19f1afc44f3e6ba8f202f6fbc.png";